import React from 'react'

import { WrapLayout } from './styles'
import { Result } from '../Ant'

export default function UserDataLoader() {
  return (
    <WrapLayout>
      <Result status="info" title="common.initial-loading" />
    </WrapLayout>
  )
}
